<template>
  <div class="row" v-if="$store.state.userData || $store.state.managerData">
    <div class="col-sm-12 text-center" v-if="($store.state.userData && $store.state.userData.documents.length === 0) && ($store.state.managerData && $store.state.managerData.documents.length === 0)">
      <div class="card">
        <div class="card-content">
          <h2>No Online Documents Available</h2>
        </div>
      </div>
    </div>
    <div v-for="document in $store.state.userData ? $store.state.userData.documents : $store.state.managerData.documents" :key="document.ID" class="col-sm-6">
      <div class="card">
        <div class="card-content">
          <div class="row">
            <div class="col-xs-3">
              <div class="text-center icon-danger" style="font-size: 6em; width: inherit"><i class="fa fa-file-pdf-o"></i></div>
            </div>
            <div class="col-xs-9">
              <h4 class="card-title">{{ document.Name }}</h4>
              <p class="category">{{ document.Description }}</p><br>
              <button class="btn btn-fill text-center" @click="downloadDocument(document)"><span class="ti-download"></span> Download</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table class="table-striped"
                      :data="[{'test': 5}]"
                      border
                      style="width: 100%">
    </el-table>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { Table } from 'element-ui'

  Vue.use(Table) // Imported to fix iOS rendering issues
  export default {
    data () {
      return {
      }
    },
    methods: {
      downloadDocument: function (file) {
        var groupName = this.$store.state.userData ? this.$store.state.userData.clientData.GroupName : this.$store.state.managerData.groups[0].GroupName
        this.$http({
          url: '/' + (this.$store.state.managerData ? 'manager' : 'client') + '/downloadDocument/' + file.ID,
          method: 'GET',
          responseType: 'blob'
        }).then((response) => {
          const blob = new Blob([response.data], {type: 'application/pdf'})
          if (window.navigator.msSaveOrOpenBlob) { // IE 11+
            window.navigator.msSaveOrOpenBlob(blob, groupName + ' - ' + file.Name + '.pdf')
          } else {
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download',
              groupName + ' - ' + file.Name + '.pdf')
            // link.setAttribute('target', '_blank')
            document.body.appendChild(link)
            link.click()
          }
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Documents.vue